import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Fortigate } from '@app/shared/models/fortigate/fortigate.model';


@Component({
    selector: 'app-fortigate-card',
    templateUrl: './fortigate-card.component.html',
    styleUrls: ['./fortigate-card.component.css'],
    standalone: false
})
export class FortigateCardComponent implements OnInit, OnDestroy {
    @Input() fortigate: Fortigate;

    constructor() {}

    ngOnInit() {}
    ngOnDestroy() {}


}